import script from "./ProfileEducation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileEducation.vue?vue&type=script&setup=true&lang=js"

import "./ProfileEducation.vue?vue&type=style&index=0&id=df4f8b1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df4f8b1c"]])

export default __exports__